import { NavigationExtras } from "@angular/router";
import { createAction, props } from "@ngrx/store";

export const routerNavigate = createAction(
  '[Hub] Navigate to page',
  props<{ commands: any[], extras?: NavigationExtras }>()
);

